export default function ConvertToDate(value?: Date): Date | undefined {
    if (typeof(value) === "string"){
        value = new Date(value);
    }

    return value;
}